import { Drawer } from '@mui/material';
import { COLOR, TRANSPARENT_COLOR } from '@src/styles/color';
import styled from 'styled-components';

export const StyledFilterDrawer = styled('div')`
  .drawer-title-filter {
    display: flex;
    gap: 12px;
    position: sticky;
    top: 0;
    z-index: 9999;
    background-color: ${COLOR.white};
    align-items: center;
    padding: 12px 16px;
    margin-bottom: 16px;
    svg:hover {
      cursor: pointer;
    }

    .title {
      font-size: 16px;
      font-weight: bold;
      text-transform: none;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      color: ${COLOR.label2[100]};
      text-overflow: ellipsis;
    }
  }

  .filter-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
`;

export const StyledFilter = styled('div')`
  padding: 0 16px 16px 16px;
  gap: 8px;
  flex-direction: column;
  display: flex;
`;

export const StyledSortItem = styled('div')`
  padding: 8px 12px;
  border-radius: 8px;
  height: 40px;
  box-sizing: border-box;
  background-color: ${(props) =>
    props.active ? COLOR.backgroundLinearProgress : COLOR.white};
  cursor: pointer;
  &:hover {
    background-color: ${COLOR.backgroundLinearProgress};
  }
`;

export const StyledAdvancedFilter = styled('div')`
  box-sizing: border-box;
  padding: 0 16px 0 16px;
`;

export const StyledDrawer = styled(Drawer)`
  .MuiPaper-root {
    border-radius: 16px 16px 0px 0px;
    padding-bottom: ${(props) => (props.isOpenSort ? '16px' : '0px')};
    height: ${(props) => (props.isOpenSort ? 'max-content' : '90%')};
    padding: ${(props) => props.style?.padding || '0px'};
    box-sizing: ${(props) => props.style?.boxSizing || 'border-box'};
  }
  .drawer-title {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid ${COLOR.borderFilterInput};

    svg:hover {
      cursor: pointer;
    }

    .title {
      font-size: 16px;
      font-weight: bold;
      text-transform: none;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      color: ${COLOR.label2[100]};
      text-overflow: ellipsis;
    }
  }

  .create-voice-button {
    margin: 16px 16px 0px 16px;
  }
`;

export const StyledLoading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  background-color: #fff;
`;

export const StyledVoiceDrawer = styled.div`
  width: 100%;
  overflow: auto;
  margin: 0px;

  &::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  &::-webkit-scrollbar-track {
    background: ${COLOR.white};
  }
  &::-webkit-scrollbar-thumb {
    background: ${COLOR.indigo[64]};
    border-radius: 100px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: ${COLOR.indigo[80]};
    border-radius: 100px;
  }

  .list {
    padding: 0 12px;
  }

  .list-item {
    font-size: 16px;
    font-weight: 500;
    box-sizing: border-box;
    min-width: 100px;
    margin: 0px;
    background: ${(props) =>
      props.active ? TRANSPARENT_COLOR.primary : COLOR.white};
  }

  .list-item:last-child {
    margin-bottom: 0;
    border-bottom: 0px;
  }

  .MuiListItem-root {
    padding: 0px;
  }

  .list-item .MuiListItemButton-root {
    width: 100%;
    height: 100%;
    padding: 0px;
    border-bottom: 1px solid ${COLOR.label[16]};
    background: ${(props) =>
      props.active ? TRANSPARENT_COLOR.primary : COLOR.white};
  }

  .empty-voices {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    min-height: 400px;
  }

  .avatar-badge-icon {
    width: 16px;
    height: 16px;
  }
`;

export const StyledVoice = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 16px 0px;
  margin: 0px;
  border: none;
  background-color: transparent;
  .content {
    display: flex;
    flex-direction: column;
    padding: 0px 4px 0px 8px;
    flex: 1;
    gap: 4px;
  }

  .more-info-voice-box {
    display: flex;
    align-items: center;
    gap: 4px;

    .tag-voice-cloning-rentention-days {
      background-color: ${COLOR.activeMenu};
      padding: 2px 8px;
      border-radius: 500px;
      font-size: 12px;
      color: ${COLOR.darkBlue};
      height: 24px;
      letter-spacing: -0.4px;
      display: flex;
      align-items: center;
      text-align: center;
    }

    .tag-voice {
      background-color: ${COLOR.primary};
      padding: 2px 8px;
      border-radius: 500px;
      font-size: 12px;
      color: ${COLOR.darkBlue};
      height: 24px;
      letter-spacing: -0.4px;
      display: flex;
      align-items: center;
      text-align: center;
    }
    .tag-voice-beta {
      background-color: #007aff29;
      padding: 2px 8px;
      border-radius: 500px;
      font-size: 12px;
      color: #007aff;
      height: 24px;
      letter-spacing: -0.4px;
      display: flex;
      align-items: center;
      text-align: center;
    }

    .eol-tag-name {
      border-radius: 500px;
      font-size: 12px;
      height: 24px;
      color: ${COLOR.redPrimary};
      letter-spacing: -0.4px;
      display: flex;
      align-items: center;
      text-align: center;
      gap: 4px;

      .returning-error-icon {
        color: ${COLOR.redPrimary};
        font-size: 14px;
        cursor: pointer;
      }
    }
  }

  .discontinued-title {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: -0.4px;
    color: ${COLOR.redPrimary};
    font-weight: 400;
    .returning-error-icon {
      font-size: 14px;
      margin-right: 4px;
    }
  }

  .trending-label {
    border: 1px solid ${COLOR.functionalPink[16]};
    background-color: ${COLOR.functionalPink[4]};
    gap: 4px;
    font-size: 12px;
    border-radius: 500px;
    padding: 2px 8px;
    box-sizing: border-box;
    height: 24px;
    display: flex;
    align-items: center;
    margin-left: 4px;
    text-align: center;
  }

  .x2-char-tag {
    background-color: #007aff14;
    color: #007aff;
    font-size: 12px;
    border-radius: 500px;
    padding: 2px 8px;
    box-sizing: border-box;
    height: 24px;
    display: flex;
    align-items: center;
    margin-left: 4px;
    text-align: center;
  }

  .voice-name {
    font-size: 14px;
    font-style: normal;
    font-weight: 510;
    line-height: 20px; /* 150% */
    letter-spacing: -0.4px;
    text-align: left;
    color: ${COLOR.descriptionGray};
    display: flex;
    align-items: center;
  }

  .voice-infor {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
    letter-spacing: -0.4px;
    color: ${COLOR.label[64]};
  }

  .icon-button {
    padding: 6px;
  }

  .play-icon {
    padding: 0px;
  }
`;

export const StyledVoiceFilter = styled.div`
  display: flex;
  gap: 10px;
  border-radius: 12px;
  margin: 8px 16px 0 16px;

  .MuiTabs-scroller {
    overflow-x: auto !important;
    ::-webkit-scrollbar {
      display: none; /* Hides the scrollbar */
    }
  }

  .MuiTabs-flexContainer {
    height: 100%;
    width: max-content;
  }

  .MuiTabs-indicator {
    height: 2px;
    background-color: ${COLOR.darkBlue};
  }

  .MuiTab-root {
    min-height: unset;
    padding: 12px 8px;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: ${COLOR.colorGrayV2};
    text-transform: none;
    white-space: nowrap;
    min-width: max-content !important;
    flex: 1;
  }

  .Mui-selected {
    font-weight: 500;
    color: ${COLOR.darkGray};
  }

  .filter-button {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px 8px;
    border-radius: 12px;
    background-color: transparent;
    cursor: pointer;
    text-transform: none;
    color: ${COLOR.label2[48]};
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
  }

  .active-button {
    background-color: ${COLOR.white} !important;
    color: ${COLOR.indigo[100]} !important;
  }
`;
